import PropTypes from 'prop-types'
import { Chip } from '@mui/material'
import WarningAmberIcon from '@mui/icons-material/WarningAmber'
import TouchAppIcon from '@mui/icons-material/TouchApp'
import ArrowForwardIcon from '@mui/icons-material/ArrowForward'

function Stat({ value, label }) {
  return (
    <div className="stat-block">
      <div className="stat-value">{value}</div>
      <div className="stat-label">{label}</div>
    </div>
  )
}

Stat.propTypes = {
  value: PropTypes.string.isRequired,
  label: PropTypes.string.isRequired,
}

export default function SelectionActionBar({
  active,
  stats,
  conflicts,
  idleHint,
  actionLabel,
  onClear,
  onAction,
}) {
  return (
    <div className="selection-action-bar d-flex align-items-center gap-3 flex-wrap">
      {active ? (
        <div className="d-flex align-items-center gap-3 flex-wrap">
          {stats.map((s, i) => (
            <div key={s.label} className="d-flex align-items-center gap-3">
              {i > 0 && <div className="stat-divider d-none d-sm-block" />}
              <Stat value={s.value} label={s.label} />
            </div>
          ))}
          {conflicts > 0 && (
            <>
              <div className="stat-divider d-none d-sm-block" />
              <Chip
                size="small"
                icon={<WarningAmberIcon />}
                color="warning"
                variant="outlined"
                label={`${conflicts} ${conflicts === 1 ? 'conflict' : 'conflicts'}`}
              />
            </>
          )}
        </div>
      ) : (
        <div className="d-flex align-items-center gap-2" style={{ color: '#666' }}>
          <TouchAppIcon fontSize="small" />
          <span style={{ fontSize: 13 }}>{idleHint}</span>
        </div>
      )}

      <div className="ms-auto d-flex align-items-center gap-2">
        {active && (
          <button className="cancelbtn btn-ch" onClick={onClear} type="button">
            Clear
          </button>
        )}
        <button
          className="secondarybtn btn-ch d-flex align-items-center gap-1"
          onClick={onAction}
          type="button"
          style={!active ? { opacity: 0.5, cursor: 'not-allowed', color: '#fff' } : { color: '#fff' }}
        >
          {actionLabel}
          <ArrowForwardIcon style={{ fontSize: 16 }} />
        </button>
      </div>
    </div>
  )
}

SelectionActionBar.propTypes = {
  active:      PropTypes.bool.isRequired,
  stats:       PropTypes.array.isRequired,
  conflicts:   PropTypes.number.isRequired,
  idleHint:    PropTypes.string.isRequired,
  actionLabel: PropTypes.string.isRequired,
  onClear:     PropTypes.func.isRequired,
  onAction:    PropTypes.func.isRequired,
}
